// src/components/Footer.jsx
import React from 'react';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section about">
          <h3>About Typing Test</h3>
          <p>Typing Test offers a variety of typing speed tests to help improve your typing skills. Challenge yourself and track your progress with our easy-to-use interface and comprehensive analytics.</p>
        </div>
        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/about-typing-clicking-tests">About</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Typing Test. All rights reserved.</p>
      </div>
    </footer>
  );
}
